import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import useCopyText from 'hooks/useCopyText'

import { titleCase } from '../../../../utils/common'
import styles from './HoverCard.module.scss'

const CopyButton = ({ valueToCopy }) => {
  const copy = useCopyText()

  if (!valueToCopy) {
    return null
  }

  return (
    <button className={styles.copyButton} onClick={() => copy(valueToCopy)}>
      <CopyIcon />
    </button>
  )
}

const HoverCard = ({
  invitedSubscriberName,
  invitedFormattedAddress,
  invitedPhoneNumber,
  invitedEmail,
  inviteBookingConversionDetailId,
  convertedClientName,
  convertedFormattedAddress,
  convertedPhoneNumber,
  convertedConfirmationCode,
  convertedEmail,
  isExcluded,
  className
}) => {
  return (
    <div className={`${styles.hovercard} ${className}`}>
      <div className={styles.compareHolder}>
        <div>
          <p className={styles.invitedTitle}>Invited</p>
          <p className={styles.value}>
            <b>{titleCase(invitedSubscriberName || 'Name unknown')}</b>
          </p>
          <p className={styles.value}>
            {invitedFormattedAddress || 'Address unknown'}{' '}
            <CopyButton valueToCopy={invitedFormattedAddress} />
          </p>
          <p className={styles.value}>
            {invitedPhoneNumber || 'Phone unknown'}
            <CopyButton valueToCopy={invitedPhoneNumber} />
          </p>
          <p className={styles.value}>
            {invitedEmail ? invitedEmail.toLowerCase() : 'Email unknown'}
            <CopyButton valueToCopy={invitedEmail} />
          </p>
        </div>
        <div>
          <p className={styles.convertedTitle}>Converted</p>
          <p className={styles.value}>
            <b>{titleCase(convertedClientName || 'Name unknown')}</b>
          </p>
          <p
            className={[
              styles.value,
              isExcluded('convertedaddress') ? styles.blacklistedText : ''
            ].join(' ')}
          >
            {convertedFormattedAddress || 'Address unknown'}
            <CopyButton valueToCopy={convertedFormattedAddress} />
          </p>
          <p
            className={[
              styles.value,
              isExcluded('convertedphonenumber') ? styles.blacklistedText : ''
            ].join(' ')}
          >
            {convertedPhoneNumber || 'Phone unknown'}
            <CopyButton valueToCopy={convertedPhoneNumber} />
          </p>
          <p
            className={[
              styles.value,
              isExcluded('convertedemailaddress, ConvertedEmailDomain')
                ? styles.blacklistedText
                : ''
            ].join(' ')}
          >
            {convertedEmail ? convertedEmail.toLowerCase() : 'Email unknown'}
            <CopyButton valueToCopy={convertedEmail} />
          </p>
          <p className={styles.value}>
            Confirmation: {convertedConfirmationCode}{' '}
            <CopyButton valueToCopy={convertedConfirmationCode} />
          </p>
          <p className={styles.value}>
            Conversion detail id: {inviteBookingConversionDetailId}{' '}
            <CopyButton valueToCopy={inviteBookingConversionDetailId} />
          </p>
        </div>
      </div>
    </div>
  )
}

export default HoverCard
